import {Location} from '@angular/common';
import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {ImageCropperPluginsComponent} from '../../../../components/image-cropper-plugins/image-cropper-plugins.component';
import {AliyunService} from '../../../../services/aliyun/aliyun.service';
import {ImageCropperService} from '../../../../services/image-cropper/image-cropper.service';
import {RoutingCenterService} from '../../../../services/routing-center/routing-center.service';
import {UserInfoService} from '../../../../services/user-info/user-info.service';


@Component({
  selector: 'bw-index-side',
  templateUrl: './index-side.component.html',
  styleUrls: ['./index-side.component.scss']
})
export class IndexSideComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(ImageCropperPluginsComponent) cropperRef: ImageCropperPluginsComponent;

  subscription: Subscription;
  imgSubscription: Subscription;
  sideRouting: Array<any>= [];
  sidePath: string;

  constructor (public userInfo: UserInfoService,
               private imgCropperService: ImageCropperService,
               private aliyunService: AliyunService,
               private routingCenter: RoutingCenterService,
               private router: Router,
               private location: Location) {
  }

  ngOnInit () {
    this.sideRouting = this.routingCenter.getSideRouting();
    const pathArr = this.location.path().toString().split('/');
    pathArr.splice(0, 1);
    this.sidePath = pathArr.join('/');
    this.sideRouting.forEach((item) => {
      item.subRouting.forEach((subItem, idx) => {
        subItem.sideColor = '';
        if (subItem.path === this.sidePath) {
          subItem.sideColor = 'color-white';
        }
      });
    });
    console.log(this.sideRouting);
  }

  onSignOut () {
    this.router.navigate([this.userInfo.userInfo.authority + '/login']);
    localStorage.clear();
  }

  onUpdatePassword () {
    this.router.navigate([this.userInfo.userInfo.authority + '/reset-password']);
    localStorage.clear();
  }

  ngAfterViewInit () {

  }
  // findRoleName(roleName: string): boolean {
  //   return this.userInfo.userInfo.app.filter((app) => {
  //     return app.role[0].roleName === roleName;
  //   }).length > 0;
  // }
  //
  // findRole(appPath: string): boolean {
  //   return this.userInfo.userInfo.app.filter(app => app.appPath === appPath).length > 0
  // || (appPath.indexOf('-demo') > 0 && localStorage.getItem('demo') != undefined);
  // }

  httpUpdateImg (url: string) {
    // this.loadingService.show();
    // let adminId = this.userInfo.userInfo.adminId;
    // this.imgSubscription = this.mentalsealAdminService.patch(adminId, {
    //   avatarUrl: url
    // }).subscribe((response) => {
    //   this.loadingService.hide();
    //   localStorage.setItem("userInfo", JSON.stringify(response.data.admin));
    //   this.userInfo.userInfo.avatarUrl = response.data.admin.avatarUrl;
    // }, (error: any) => {
    //   this.sweetAlertService.showALert({
    //     title: "请求错误",
    //     text: error.result.displaymsg,
    //     type: "error",
    //     showCancelButton: false
    //   })
    // });
  }

  updateImg () {
    this.imgCropperService.showModal(this.cropperRef);
    this.subscription = this.aliyunService.engineStatus.subscribe((status: boolean) => {
      (status) ? this.httpUpdateImg(this.aliyunService.getUrlForBase64()) : swal('AliyunService request error!!!', '', 'error');
      this.subscription.unsubscribe();
    });
  }

  onClickSide (itemIdx: number, index: number) {
   this.sideRouting.forEach((item) => {
     item.subRouting.map((subItem) =>
       subItem.sideColor = '');
   });
   this.sideRouting[itemIdx].subRouting[index].sideColor = 'color-white';
  }

  ngOnDestroy () {
    try {
      this.subscription.unsubscribe();
      this.imgSubscription.unsubscribe();
    } catch (e) {}
  }
}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/module/index-operation/index/index-side/index-side.component.ts